<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 10:34:56
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 10:53:12
 * @FilePath: /chaoyongtuan/src/views/contentLibray/contentLibray.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <router-view></router-view>
  </template>
  
  <script>
  export default {
  name: "index"
  }
  </script>
  
  <style scoped>
  
  </style>
  